import React, { useRef, useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Backdrop } from '..';
import Wrapper from './style';

const Index = (props) => {
  const { showNote, children, title, subTitle, width, noScroll, onClose } =
    props;

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, []);

  return (
    <>
      <Backdrop show={showNote} onClickBackdrop={onClose} />
      <Wrapper
        show={showNote}
        className="component_note"
        width={width}
        noScroll={noScroll}
      >
        <div className="component_note_title">
          <div>
            <div className="font-paragraph_medium black4">
              {subTitle ||
                'Collaboration with your team members by leaving a note'}
            </div>
            <div className="font-subtitle1_medium black1">
              {title || 'Note Title'}
            </div>
          </div>
          <CloseOutlined onClick={onClose} />
        </div>
        <div className="component_note_content">{children}</div>
      </Wrapper>
    </>
  );
};

export default Index;
